import React from 'react'
import { Link } from 'gatsby'
import { useFirebase } from "gatsby-plugin-firebase"

import pic01 from '../assets/images/markus-spiske-N_TFAu9gtf0-unsplash.jpg'
import pic02 from '../assets/images/markus-spiske-2VMcpbUR6w8-unsplash.jpg'
import pic04 from '../assets/images/sharon-mccutcheon-tn57JI3CewI-unsplash.jpg'
import pic05 from '../assets/images/burst-kUqqaRjJuw0-unsplash.jpg'

const Main = () => {
    useFirebase(firebase => {
        firebase
          .analytics()
          .logEvent("visited_home")
      }, [])

      return (
            <div id="main">
                <section id="one" className="tiles">
                    <article style={{backgroundImage: `url(${pic01})`}}>
                        <header className="major2">
                            <h3>O projekcie</h3>
                        </header>
                        <Link to="/o-projekcie" className="link primary"></Link>
                    </article>
                    <article style={{backgroundImage: `url(${pic02})`}}>
                        <header className="major2">
                            <h3>Warunki uczestnictwa</h3>
                        </header>
                        <Link to="/warunki" className="link primary"></Link>
                    </article>
                    <article style={{backgroundImage: `url(${pic05})`}}>
                        <header className="major2">
                            <h3>Harmonogram zajęć</h3>
                        </header>
                        <Link to="/harmonogram" className="link primary"></Link>
                    </article>
                    <article style={{backgroundImage: `url(${pic04})`}}>
                        <header className="major2">
                            <h3>Pliki do pobrania</h3>
                        </header>
                        <Link to="/formularze" className="link primary"></Link>
                    </article>
                    
                </section>
                <section id="two">
                    <div className="inner">
                        <h3>Zapraszamy uczniów II i III klas szkół średnich z powiatów: nowotarskiego, suskiego i tatrzańskiego do wzięcia udziału w innowacyjnym projekcie realizowanym przez Podhalańską Państwową Uczelnię Zawodową w Nowym Targu z Narodowym Bankiem Polskim, w ramach konkursu "Uczelnie&nbsp;Szkołom – o finansach z NBP".</h3>
                        <hr />
                        <p><strong>Głównym celem projektu</strong> jest poszerzenie wiedzy i umiejętności praktycznych w zakresie rynków finansowych i zarządzania finansami osobistymi.</p>
                        <p><strong>Zajęcia będą dotyczyły następujących tematów:</strong></p>
                        <ul>
                            <li>Obrót gotówkowy i bezgotówkowy oraz bezpieczeństwo dokonywania transakcji</li>
                            <li>Oszczędzanie i inwestowanie</li>
                            <li>Kredyty, pożyczki, ubezpieczenia</li>
                            <li>Główne instytucje wpływające na stabilność ekonomiczną i finansową kraju</li>
                        </ul>
                        <hr />
                        Rekrutacja odbędzie się w dniach <strong>10 - 29 lutego </strong>br.
                        <hr />
                        <p><h3>Udział w projekcie jest bezpłatny!</h3>
                        Każdy uczestnik otrzyma certyfikat.<br />
                        Zapewniamy ciekawe zajęcia, transport, ubezpieczenie, obiad i przerwę herbacianą.</p>
                    </div>
                </section>
            </div>
    )
}

export default Main